import { type PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

import { Stack } from './Stack';

type Props = PropsWithChildren<{
  className?: string;
  width?: number;
}>;

export function ActionButtons({ children, width, className }: Props) {
  const classNames = twMerge('justify-end items-center flex grow', className);

  return (
    <Stack className={classNames}>
      <Stack gap={2} className={twMerge('w-72', `w-${width}`)}>
        {children}
      </Stack>
    </Stack>
  );
}
